export class DecimalSerializableValue {
  value?: number;

  constructor(value?: number) {
    this.value = value;
  }
}
